import { render, staticRenderFns } from "./ContractorContactsList.vue?vue&type=template&id=472f4056"
import script from "./ContractorContactsList.vue?vue&type=script&lang=js"
export * from "./ContractorContactsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports